import React, { useEffect, useState, useRef, createElement } from 'react';
export const VideoPlayer = () => {
  const playerScriptRef = useRef<HTMLScriptElement | null>(null);
  const embedScriptRef = useRef<HTMLScriptElement | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  useEffect(() => {
    const loadScripts = async () => {
      try {
        if (!playerScriptRef.current) {
          const playerScript = document.createElement('script');
          playerScript.src = 'https://fast.wistia.com/player.js';
          playerScript.async = true;
          playerScript.crossOrigin = 'anonymous';
          playerScript.onerror = () => {
            console.error('Failed to load Wistia player script');
            setHasError(true);
          };
          playerScriptRef.current = playerScript;
          document.head.appendChild(playerScript);
          await new Promise((resolve, reject) => {
            playerScript.onload = resolve;
            playerScript.onerror = reject;
          });
        }
        if (!embedScriptRef.current) {
          const embedScript = document.createElement('script');
          embedScript.src = 'https://fast.wistia.com/embed/tmwt1c6a61.js';
          embedScript.async = true;
          embedScript.crossOrigin = 'anonymous';
          embedScript.type = 'module';
          embedScript.onerror = () => {
            console.error('Failed to load Wistia embed script');
            setHasError(true);
          };
          embedScriptRef.current = embedScript;
          document.head.appendChild(embedScript);
          await new Promise((resolve, reject) => {
            embedScript.onload = resolve;
            embedScript.onerror = reject;
          });
        }
        setIsLoading(false);
      } catch (error) {
        console.error('Error loading Wistia scripts:', error);
        setHasError(true);
        setIsLoading(false);
      }
    };
    loadScripts();
    return () => {
      if (playerScriptRef.current && document.head.contains(playerScriptRef.current)) {
        document.head.removeChild(playerScriptRef.current);
      }
      if (embedScriptRef.current && document.head.contains(embedScriptRef.current)) {
        document.head.removeChild(embedScriptRef.current);
      }
    };
  }, []);
  if (hasError) {
    return <div className="relative w-full max-w-md mx-auto rounded-lg overflow-hidden bg-gray-900 aspect-[9/16] flex items-center justify-center" data-id="element-806">
        <p className="text-white text-center px-4" data-id="element-807">
          Unable to load video player. Please refresh the page or try again
          later.
        </p>
      </div>;
  }
  return <div className="relative w-full max-w-md mx-auto rounded-lg overflow-hidden" data-id="element-808">
      <style data-id="element-809">
        {`
          wistia-player[media-id='tmwt1c6a61']:not(:defined) {
            background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/tmwt1c6a61/swatch');
            display: block;
            filter: blur(5px);
            padding-top: 177.78%;
          }
        `}
      </style>
      <wistia-player media-id="tmwt1c6a61" aspect="0.5625" className="rounded-lg w-full" data-id="element-810" />
      {isLoading && <div className="absolute inset-0 bg-gray-900 bg-opacity-50 flex items-center justify-center" data-id="element-811">
          <div className="animate-spin rounded-full h-12 w-12 border-4 border-white border-t-transparent" data-id="element-812" />
        </div>}
    </div>;
};